<!-- Form -->
@if (edit() || handleEdit()) {
  <form [formGroup]="giftForm()">
    <div class="flex items-center mt-6 mb-4 px-4 gap-4">
      <input [id]="'toMe-' + id" [value]="true"
             class="w-7 h-7 text-gray-700 ring-gray-200 focus:ring-gray-700 focus:ring-2" formControlName="sentToMe"
             type="radio">
      <label [for]="'toMe-' + id"
             class="ms-2 font-medium text-sm md:text-md">{{ (isCoupon() ? 'sentToMeCoupon' : 'sentToMe') | translate }}</label>
    </div>
    <div class="flex items-center gap-4 px-4">
      <input [id]="'notToMe-' + id" [value]="false"
             class="w-7 h-7 text-gray-700 ring-gray-200 focus:ring-gray-700 focus:ring-2" formControlName="sentToMe"
             type="radio">
      <label [for]="'notToMe-' + id"
             class="ms-2 font-medium text-sm md:text-md">{{ (isCoupon() ? 'sentToOtherCoupon' : 'sentToOther') | translate }}</label>
    </div>
    <p class="font-semibold text-xl mt-12 mb-6">{{ 'formatChoice' | translate }}</p>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <label [for]="'eTicket-' + id"
             [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
             class="flex items-start justify-between gap-4 px-6 py-8 rounded-lg">
        <p class="ms-2 font-medium text-md whitespace-pre-line">{{ 'formatETicket' | translate }}</p>
        <input [id]="'eTicket-' + id" [value]="GiftFormat.eTicket"
               class="w-8 h-8 text-vertCaliceo-100 ring-gray-200 focus:ring-vertCaliceo-100 focus:ring-2"
               formControlName="format"
               type="radio">
      </label>
      <label [for]="'mail-' + id" [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
             class="flex items-start justify-between gap-4 px-6 py-8 rounded-lg">
        <p
          class="ms-2 font-medium text-md whitespace-pre-line">{{ 'formatMail' | translate: { fee: siteService.price(productService.managementFee().id).price | currency } }}</p>
        <input [id]="'mail-' + id" [value]="GiftFormat.mail"
               class="w-8 h-8 text-vertCaliceo-100 ring-gray-200 focus:ring-vertCaliceo-100 focus:ring-2"
               formControlName="format"
               type="radio">
      </label>
    </div>
    <div class="pt-4 ms-2 font-medium text-sm md:text-md">
      {{ 'requiredFields' | translate }}
    </div>
    <div class="relative">
      <input
        [attr.aria-describedby]="'fromCount-' + id"
        [id]="'from-' + id"
        [maxlength]="AQUAO_OFFREUR_MAX"
        [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
        class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base"
        formControlName="from">
      <label [for]="'from-' + id"
             class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
        {{ 'from' | translate }}
      </label>
      <app-character-count [attr.id]="'fromCount-' + id" [max]="AQUAO_OFFREUR_MAX"
                           [value]="giftForm().get('from')?.value ?? ''"/>
    </div>
    @if (!giftForm().get('sentToMe')?.value && giftForm().get('format')?.value === GiftFormat.mail) {
      <div class="flex flex-col md:flex-row md:gap-4">
        <div class="relative grow">
          <input
            [attr.aria-describedby]="'beneficiaryCombinedCount-' + id"
            [id]="'beneficiaryFirstName-' + id"
            [maxlength]="AQUAO_DESTINATAIRE_MAX"
            [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
            class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base"
            formControlName="firstName">
          <label [for]="'beneficiaryFirstName-' + id"
                 class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
            {{ 'beneficiaryFirstName' | translate }}
          </label>
        </div>
        <div class="relative grow">
          <input
            [attr.aria-describedby]="'beneficiaryCombinedCount-' + id"
            [id]="'beneficiaryName-' + id"
            [maxlength]="AQUAO_DESTINATAIRE_MAX"
            [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
            class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base"
            formControlName="lastName">
          <label [for]="'beneficiaryName-' + id"
                 class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
            {{ 'beneficiaryName' | translate }}
          </label>
          <p [id]="'beneficiaryCombinedCount-' + id"
             [ngClass]="giftForm().hasError('destinataireMaxLength') ? 'text-red-600' : 'text-gray-500'"
             aria-atomic="true"
             aria-live="polite"
             class="mt-1 text-right text-xs tabular-nums">
            {{ combinedRecipientName(giftForm()).length }} / {{ AQUAO_DESTINATAIRE_MAX }}
            @if (giftForm().hasError('destinataireMaxLength')) {
              <span class="block font-medium">
                {{ 'giftRecipientCombinedMaxLength' | translate : { max: AQUAO_DESTINATAIRE_MAX.toString() } }}
              </span>
            }
          </p>
        </div>
      </div>
    }
    @if (displayAddressForm()) {
      <div class="relative">
        <input
          [attr.aria-describedby]="'beneficiaryAddressCount-' + id"
          [id]="'beneficiaryAddress-' + id"
          [maxlength]="AQUAO_ADDRESS_MAX"
          [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
          class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base"
          formControlName="address">
        <label [for]="'beneficiaryAddress-' + id"
               class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
          {{ (sentToMe() ? 'myAddress' : 'beneficiaryAddress')| translate }}
        </label>
        <app-character-count [attr.id]="'beneficiaryAddressCount-' + id" [max]="AQUAO_ADDRESS_MAX"
                             [value]="giftForm().get('address')?.value ?? ''"/>
      </div>
      <div class="flex flex-col md:flex-row gap-4 mt-5">
        <div [class.z-30]="displayCities()" class="relative grow">
          <input
            [id]="'beneficiaryZIP-' + id"
            [maxlength]="FRENCH_ZIP_LENGTH"
            [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
            class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base"
            formControlName="zip"
            inputmode="numeric"
            autocomplete="postal-code">
          <label [for]="'beneficiaryZIP-' + id"
                 class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
            {{ (sentToMe() ? 'myZIP' : 'beneficiaryZIP')| translate }}
          </label>
          @if (displayCities()) {
            <div class="absolute left-0 top-full z-50 mt-1 w-full min-w-56">
              <div
                class="rounded-xl bg-white p-4 text-sm font-semibold leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                @for (city of cities(); track city) {
                  <button (click)="setCity(city)" class="block w-full p-2 text-left hover:text-bleuCaliceo-400" type="button">
                    {{ city }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
        <div class="relative grow">
          <input
            [disabled]="true"
            [id]="'beneficiaryCity-' + id"
            [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
            [value]="giftForm().get('city')?.value"
            class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base disabled:opacity-100"
            autocomplete="address-level2"
            type="text">
          <label [for]="'beneficiaryCity-' + id"
                 class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
            {{ (sentToMe() ? 'myCity' : 'beneficiaryCity')| translate }}
          </label>
        </div>
      </div>
    } @else {
      <div class="relative">
        <input
          [attr.aria-describedby]="'beneficiaryEmailCount-' + id"
          [id]="'beneficiaryEmail-' + id"
          [maxlength]="AQUAO_EMAIL_MAX"
          [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
          class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base"
          formControlName="email">
        <label [for]="'beneficiaryEmail-' + id"
               class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
          {{ (sentToMe() ? 'myEmail' : 'beneficiaryEmail')| translate }}
        </label>
        <app-character-count [attr.id]="'beneficiaryEmailCount-' + id" [max]="AQUAO_EMAIL_MAX"
                             [value]="giftForm().get('email')?.value ?? ''"/>
      </div>
    }
    <div class="relative">
    <textarea [attr.aria-describedby]="'beneficiaryMessageCount-' + id"
              [id]="'beneficiaryMessage-' + id"
              [maxlength]="AQUAO_TEXT_UX_MAX"
              [ngClass]="theme() === 'gift' ? 'bg-white' : 'bg-beige'"
              class="px-4 pt-6 pb-2 rounded-lg border-none w-full mt-5 font-medium text-base resize-none"
              formControlName="message"
              rows="3"></textarea>
      <label [for]="'beneficiaryMessage-' + id"
             class="absolute text-xs text-gray-500 top-6 z-10 left-4 pt-1">
        {{ 'beneficiaryMessage' | translate }}
      </label>
      <app-character-count [attr.id]="'beneficiaryMessageCount-' + id" [max]="AQUAO_TEXT_UX_MAX"
                           [value]="giftForm().get('message')?.value ?? ''"/>
    </div>
    @if (!giftForm().get('sentToMe')?.value) {
      <div class="bg-beige p-4 rounded-xl mt-4">
        <p class="font-medium text-sm md:text-base"> {{ 'sendingDate' | translate }} : </p>
        @if (giftForm().get('format')?.value === GiftFormat.mail) {
          <p class="font-medium text-xs md:text-xs"> {{ 'sendingInfo' | translate }} </p>
        }
        <app-date-picker (selectedChange)="updateShipDate($event)" [notBefore]="today"
                         [selected]="shipDateAsDate()"></app-date-picker>
      </div>
    }
    <button [appProgressClick]="submit"
            [disabled]="giftForm().invalid || !canBeSubmitted()"
            appHoverGradient
            class="flex items-center gap-3 mt-5 w-full justify-center bg-bleuCaliceo-300"
            type="button">
      {{ 'validate' | translate }}
      <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="4" viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg">
        <path d="m4.5 12.75 6 6 9-13.5"/>
      </svg>
    </button>
  </form>
}
